module.exports = __webpack_public_path__ + "static/media/editable-icon.7edf5715.svg";